export const properties  = {
    RESOURCE : 'dateTime',
    DATE_TIME_SEPARATOR : ' ',
    TIME_SEPARATOR: ':',
    DATE_SEPARATOR: '-',
    ONE_SECOND: '1000'
}